import { Button, Typography } from '@mui/material'
import SectionTitle from '../../components/section-title/SectionTitle'
import { Link, Navigate } from 'react-router-dom'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getHomeRouteForRole } from 'routes/routes'
import { selectCurrentUserRoles, warningSnack } from 'features'
import { useSelector, useDispatch } from 'react-redux'

function Error401(_props) {
  const {
    title = 'No autorizado',
    message = 'No estas autorizado para ver esta página.',
    actionLabel = 'Volver al inicio',
    activeRole = '',
  } = _props

  const dispatch = useDispatch()
  const currentUserRole = useSelector(selectCurrentUserRoles)

  const titleWithWarning = (
    <span className="text-error">
      <FontAwesomeIcon icon={faWarning} size={'1x'} />
      &nbsp;{title}
    </span>
  )

  if (
    currentUserRole[0] === process.env.REACT_APP_MASTER_ROLE &&
    process.env.REACT_APP_ENABLE_ROLE_SWAP === 'true'
  ) {
    dispatch(
      warningSnack({
        message: 'Redireccionado a página de inicio de Rol ' + activeRole,
      })
    )
    return <Navigate to={getHomeRouteForRole(activeRole)} replace={true} />
  }

  return (
    <div className="py-20">
      <SectionTitle title={titleWithWarning} className="mb-8" />
      <Typography variant="h3" component="p" className="mb-8">
        {message}
      </Typography>
      <Button
        component={Link}
        to={getHomeRouteForRole(activeRole)}
        variant="contained"
        color="primary"
      >
        {actionLabel}
      </Button>
    </div>
  )
}

export default Error401
